<!--
 * @Descripttion: 
 * @Author: congz
 * @Date: 2020-07-22 13:14:57
 * @LastEditors: congz
 * @LastEditTime: 2020-08-13 10:34:49
--> 
<template>
  <div class="order-details" id="order-details" name="order-details">
    <div class="order-details-layout" v-if="order">
      <el-row :gutter="10">
        <div>
          <CenterMenu></CenterMenu>
        </div>
        <el-col :span="20">
          <div class="order-details-content">
            <div class="extra"></div>
            <div class="order-details-title">
              <p>Order Details</p>
            </div>
            <div class="order-operate">
              <div class="order-num">Order Number ：{{order.order_num}}</div>
              <div class="order-button" v-if="order.type !== 2">
                <el-button class="pay" size="small" style="width:120px" @click="payNow">Pay Now</el-button>
              </div>
            </div>
            <div class="order-step-info" v-if="order.type !== 2">Awaiting payment</div>
            <div class="order-success-info" v-else>Paid</div>
            <div class="order-step">
              <el-steps
                :space="200"
                :active="order.type === 2 ? 3 : 1"
                finish-status="success"
                align-center
              >
                <el-step title="Order placed" :description="order.created_at| dateFormat"></el-step>
                <el-step title="Payment"></el-step>
                <el-step title="Shipped"></el-step>
              </el-steps>
            </div>
            <div class="extra"></div>
            <div class="extra"></div>

            <div class="order-list-product">
              <div class="pro-img">
                <router-link :to="{ path: '/goods/details', query: {productID:order.product_id} }">
                  <img :src="order.img_path" />
                </router-link>
              </div>
              <div class="pro-info">
                <span style="margin-bottom:7px">
                  <router-link
                    class="info-href"
                    :to="{ path: '/goods/details', query: {productID:order.product_id} }"
                  >{{order.name}}</router-link>
                </span>
                <span v-if="order.size" class="pro-size">Size: {{order.size}}</span>
              </div>
              <div class="pro-price">
                <span>
                  {{order.discount_price}}₹&nbsp;×
                  {{order.num}}
                </span>
              </div>
            </div>
            <div class="order-address-title">Shipping Information</div>
            <div class="order-address">
              <div class="order-address-head">
                <p>Name:</p>
                <p>Phone number :</p>
                <p>Receiving address :</p>
              </div>
              <div class="order-address-data">
                <p>{{order.address_name}}</p>
                <p>{{order.address_phone}}</p>
                <p>{{order.address}}</p>
              </div>
            </div>
            <div class="order-address-title">Payment Method</div>
            <div class="order-address">
              <div class="order-address-head">
                <p>Payment Method ：</p>
              </div>
              <div class="order-address-data">
                <p>{{order.pay_method === 'online' ? 'Online Payment (UPI)' : 'Cash on Delivery'}}</p>
              </div>
            </div>
            <div class="order-address-title">Invoice Information</div>
            <div class="order-address">
              <div class="order-address-head">
                <p>Invoice Type ：</p>
                <p>Invoice content ：</p>
                <p>Invoice Title ：</p>
              </div>
              <div class="order-address-data">
                <p>Electronic ordinary invoice</p>
                <p>Purchase product details</p>
                <p>individual</p>
              </div>
            </div>
            <!-- 结算列表 -->
            <div class="section-count">
              <div class="money-box">
                <ul>
                  <li>
                    <span class="title">Number of products：</span>
                    <span class="value">{{order.num}}</span>
                  </li>
                  <li>
                    <span class="title">Total product price：</span>
                    <span class="value">{{order.discount_price}}₹</span>
                  </li>
                  <li>
                    <span class="title">Promotional Offer：</span>
                    <span class="value">-0₹</span>
                  </li>
                  <li>
                    <span class="title">Promotional Offer：</span>
                    <span class="value">-0₹</span>
                  </li>
                  <li>
                    <span class="title">shipping cost：</span>
                    <span class="value">0₹</span>
                  </li>
                  <li class="total">
                    <span class="title">Total payable amount：</span>
                    <span class="value">
                      <span class="total-price">{{order.num*order.discount_price}}</span>₹
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="not-found" v-else>Unable to find the order</div>
    <!-- SveltPay UPI 支付弹窗 (整合了真实 paymentId + walletlink + deep links + Payment Done) -->
    <el-dialog title="UPI Online Payment" :visible.sync="upiDialogVisible" width="380px" center @close="onUpiDialogClose">
      <div v-if="upiLoading" style="text-align:center;padding:40px 0;">
        <i class="el-icon-loading" style="font-size:40px;color:#3B211C;"></i>
        <p style="margin-top:15px;color:#757575;">Initializing payment...</p>
      </div>
      <div v-else-if="upiError" style="text-align:center;padding:30px 0;">
        <i class="el-icon-warning" style="font-size:40px;color:#d63031;"></i>
        <p style="margin-top:15px;color:#d63031;">{{ upiError }}</p>
        <el-button size="small" @click="initSveltepay" style="margin-top:10px;">Retry</el-button>
      </div>
      <div v-else style="text-align:center;">
        <p style="margin-bottom:12px;color:#333;font-size:15px;margin-top:0;">Scan QR or tap a wallet to pay</p>
        <img :src="qrCodeUrl" alt="UPI QR Code" style="width:200px;height:200px;border:1px solid #eee;border-radius:6px;" />
        <p style="margin-top:12px;color:#3B211C;font-weight:600;font-size:18px;">Amount: {{payAmount}}₹</p>
        <div style="margin-top:14px;display:flex;justify-content:center;gap:10px;flex-wrap:wrap;">
          <el-button size="small" type="success" @click="openApp('gpay')">Google Pay</el-button>
          <el-button size="small" style="background:#5f259f;border-color:#5f259f;color:#fff;" @click="openApp('phonepe')">PhonePe</el-button>
          <el-button size="small" style="background:#00BAF2;border-color:#00BAF2;color:#fff;" @click="openApp('paytm')">Paytm</el-button>
          <el-button size="small" plain @click="openApp('upi')">Other UPI</el-button>
        </div>
        <p style="margin-top:14px;font-size:11px;color:#9b9b9b;">Open on mobile to pay via wallet app, or scan QR from any UPI app.</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="upiDialogVisible = false">Close</el-button>
        <el-button type="primary" :loading="verifying" @click="handleUpiDone">I have paid</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import CenterMenu from '../components/CenterMenu'
import * as ordersAPI from '@/api/orders'
import * as paymentAPI from '@/api/payment'

// UPI 深链 scheme 转换（SveltPay 的 walletlink 是 upi://pay? 开头，按不同钱包替换 scheme）
function toGpay(walletlink) {
  return walletlink ? walletlink.replace('upi://pay?', 'gpay://upi/pay?') : ''
}
function toPhonepe(walletlink) {
  return walletlink ? walletlink.replace('upi://pay?', 'phonepe://pay?') : ''
}
function toPaytm(walletlink) {
  // Paytm 必须含 featuretype=money_transfer 参数（拆开替换后追加）
  if (!walletlink) return ''
  let url = walletlink.replace('upi://pay?', 'paytmmp://cash_wallet?')
  if (url.indexOf('featuretype=') === -1) {
    url += (url.indexOf('?') > -1 ? '&' : '?') + 'featuretype=money_transfer'
  }
  return url
}
function toUpi(walletlink) {
  return walletlink || ''
}

export default {
  name: 'OrderDetails',
  data() {
    return {
      orderNum: '', // 订单num,
      order: '',
      address: '',
      upiDialogVisible: false,
      upiLoading: true,
      upiError: '',
      payAmount: 0,
      walletlink: '',
      paymentId: '',
      verifying: false,
      pollTimer: null
    }
  },
  computed: {
    qrCodeUrl() {
      // 通过公共 API 把 walletlink 编码成二维码图片
      const data = encodeURIComponent(this.walletlink || '')
      return data ? `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${data}` : ''
    },
    isMobile() {
      return window.innerWidth <= 900
    }
  },
  activated() {
    if (this.$route.query.orderNum != undefined) {
      this.orderNum = this.$route.query.orderNum
      this.load()
    }
  },
  deactivated() {
    this.stopPolling()
  },
  beforeDestroy() {
    this.stopPolling()
  },
  watch: {
    // 监听orderNum变化，重新加载
    orderNum: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.load()
      }
    }
  },
  methods: {
    load() {
      ordersAPI
        .showOrder(this.orderNum)
        .then(res => {
          if (res.status === 200) {
            this.order = res.data
            // If order is unpaid online payment, start polling
            if (res.data && res.data.type !== 2 && res.data.pay_method === 'online') {
              this.startPolling()
            } else {
              this.stopPolling()
            }
          } else if (res.status === 20001) {
            //token过期，需要重新登录
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Failed to obtain order', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain order', err)
        })
    },
    payNow() {
      // 在线支付走 DeepPay 收银台（Payment.vue：调 /api/v1/pay/init-online-pay 拿 UPI 二维码 + 轮询）
      // 注：本项目实际使用 DeepPay（DEEPPAY_* 已配置且实测可用）；SveltPay 弹窗保留但不再从这里触发
      if (!this.order || this.order.pay_method === 'cod') {
        return
      }
      this.$router.push({ path: '/payment', query: { orderNum: String(this.order.order_num) } })
    },
    initSveltepay() {
      this.upiLoading = true
      this.upiError = ''
      const amount = (this.order.num * this.order.discount_price).toFixed(2)
      this.payAmount = amount
      paymentAPI
        .initSveltPayment({
          order_num: String(this.order.order_num),
          amount: String(this.order.discount_price * this.order.num),
          nickname: this.order.address_name || 'Customer',
          phone: this.order.address_phone || '',
          email: ''
        })
        .then(res => {
          this.upiLoading = false
          if (res && res.status === 200 && res.data) {
            this.walletlink = res.data.walletlink || ''
            this.paymentId = res.data.payment_id || ''
          } else {
            this.upiError = (res && res.msg) || 'Payment init failed'
          }
        })
        .catch(err => {
          this.upiLoading = false
          this.upiError = (err && err.message) || 'Network error'
          this.notifyError('Payment init failed', err && err.message)
        })
    },
    openApp(type) {
      // 根据类型用不同 scheme 唤起钱包 App
      let url = ''
      if (type === 'gpay') url = toGpay(this.walletlink)
      else if (type === 'phonepe') url = toPhonepe(this.walletlink)
      else if (type === 'paytm') url = toPaytm(this.walletlink)
      else url = toUpi(this.walletlink)
      if (!url) {
        this.notifyError('Payment link unavailable')
        return
      }
      // 移动端：直接打开 deep link；桌面端：提示用手机扫码
      if (this.isMobile) {
        window.location.href = url
      } else {
        this.notifySucceed('Please scan the QR code using your phone')
      }
    },
    handleUpiDone() {
      // 主动校验：调用 /api/v1/orders/:num/pay
      this.verifying = true
      paymentAPI
        .verifyPaymentDone(String(this.order.order_num), this.paymentId)
        .then(res => {
          this.verifying = false
          if (res && res.status === 200 && res.data && res.data.paid) {
            this.upiDialogVisible = false
            this.notifySucceed('Payment confirmed!')
            this.load()
          } else {
            this.notifyError('Payment not received yet. If you have paid, please wait a few seconds.')
          }
        })
        .catch(err => {
          this.verifying = false
          this.notifyError('Verification failed', err && err.message)
        })
    },
    onUpiDialogClose() {
      this.walletlink = ''
      this.paymentId = ''
      this.upiError = ''
    },
    startPolling() {
      this.stopPolling()
      this.pollTimer = setInterval(() => {
        ordersAPI.showOrder(this.orderNum).then(res => {
          if (res.status === 200 && res.data) {
            this.order = res.data
            if (res.data.type === 2) {
              this.stopPolling()
              this.notifySucceed('Payment confirmed!')
              // 自动关闭弹窗
              if (this.upiDialogVisible) this.upiDialogVisible = false
            }
          }
        }).catch(() => {})
      }, 5000)
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    }
  },
  components: {
    CenterMenu
  }
}
</script>
<style scoped>
.order-details-layout {
  max-width: 1225px;
  margin: 0 auto;
}
.order-details-content {
  background-color: #ffffff;
  margin-bottom: 30px;
}
.order-details-title {
  height: 100px;
  display: flex;
  align-items: center;
}
.order-details-title p {
  font-size: 30px;
  color: #757575;
  margin-left: 50px;
}
.extra {
  height: 10px;
}
/*订单号按钮区域*/
.order-details-content .order-operate {
  width: 920px;
  margin: 0 auto;
  display: flex;
  border-bottom: 1px solid #e0e0e0;
}
.order-details-content .order-operate .order-num {
  width: 500px;
  font-size: 18px;
  margin-bottom: 17px;
  color: #242424;
}
.order-details-content .order-operate .order-button {
  margin-left: 170px;
}
.order-details-content .order-operate .order-button .pay {
  margin-left: 10px;
  background-color: #3B211C;
  color: #ffffff;
}
/*订单号按钮区域END*/
/*进度条区域*/
.order-details-content .order-step-info {
  width: 920px;
  margin: 0 auto;
  color: #3B211C;
  font-size: 18px;
  margin-top: 20px;
}
.order-details-content .order-success-info {
  width: 920px;
  margin: 0 auto;
  color: #00a724;
  font-size: 18px;
  margin-top: 20px;
}
.order-details-content .order-step {
  width: 920px;
  margin: 0 auto;
  margin-top: 40px;
}
/*进度条区域END*/
/*订单商品区域*/
.order-details-content .order-list-product {
  width: 920px;
  height: 110px;
  background-color: #ffffff;
  margin: 0 auto;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
}
.order-details-content .order-list-product .pro-img {
  margin-right: 20px;
}
.order-details-content .order-list-product .pro-img img {
  height: 80px;
  width: 80px;
}
.order-details-content .order-list-product .pro-info {
  font-size: 15px;
  color: #333333;
}
.order-details-content .order-list-product .pro-info .info-href {
  font-size: 15px;
  color: #333333;
}
.order-details-content .order-list-product .pro-info .pro-size {
  display: block;
  margin-top: 6px;
  font-size: 13px;
  color: #7A5B4E;
  font-weight: 600;
}
.order-details-content .order-list-product .pro-info .info-href:hover {
  color: #3B211C;
}
.order-details-content .order-list-product .pro-price {
  margin-left: 30px;
  font-size: 15px;
  color: #333333;
}

/*订单商品区域END*/
/*订单收货信息区域*/
.order-details-content .order-address-title {
  width: 1020px;
  margin: 0 auto;
  color: #242424;
  font-size: 18px;
  margin-top: 20px;
}
.order-details-content .order-address {
  width: 920px;
  height: 120px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
}
.order-details-content .order-address .order-address-head {
  font-size: 15px;
  line-height: 25px;
  font-weight: bold;
  color: #757575;
}
.order-details-content .order-address .order-address-data {
  font-size: 15px;
  line-height: 25px;
  color: #757575;
}
/*订单收货信息区域END*/

/* 结算列表CSS */
.order-details-content .section-count {
  margin: 0 48px;
  padding: 20px 0;
  overflow: hidden;
}
.order-details-content .section-count .money-box {
  float: right;
  text-align: right;
}
.order-details-content .section-count .money-box .title {
  float: left;
  width: 240px;
  height: 30px;
  display: block;
  line-height: 30px;
  color: #757575;
}
.order-details-content .section-count .money-box .value {
  float: left;
  min-width: 105px;
  height: 30px;
  display: block;
  line-height: 30px;
  color: #3B211C;
}
.order-details-content .section-count .money-box .total .title {
  padding-top: 15px;
}
.order-details-content .section-count .money-box .total .value {
  padding-top: 10px;
}
.order-details-content .section-count .money-box .total-price {
  font-size: 30px;
}
/* 结算列表CSS END */

/*v-else*/
.order-details .not-found {
  height: 500px;
  text-align: center;
}
/*v-else END*/

/* 手机端适配 */
@media (max-width: 900px) {
  .order-details-layout {
    max-width: 100%;
  }
  .order-details-title {
    height: auto;
    padding: 12px;
  }
  .order-details-title p {
    margin-left: 0;
    font-size: 22px;
  }
  /* 操作条与步骤信息 */
  .order-details-content .order-operate,
  .order-details-content .order-step-info,
  .order-details-content .order-success-info,
  .order-details-content .order-step {
    width: 100%;
    padding: 0 12px;
  }
  .order-details-content .order-operate {
    flex-wrap: wrap;
  }
  .order-details-content .order-operate .order-num {
    width: auto;
    margin-bottom: 8px;
  }
  .order-details-content .order-operate .order-button {
    margin-left: 0;
  }
  /* 商品列表 */
  .order-details-content .order-list-product {
    width: 100%;
    height: auto;
    padding: 12px;
    flex-wrap: wrap;
  }
  .order-details-content .order-list-product .pro-img {
    margin-right: 12px;
  }
  .order-details-content .order-list-product .pro-img img {
    width: 64px;
    height: 64px;
    border-radius: 6px;
  }
  /* 收货信息与结算列表 */
  .order-details-content .order-address-title,
  .order-details-content .order-address {
    width: 100%;
    padding: 0 12px;
    height: auto;
  }
  .order-details-content .section-count {
    margin: 0;
    padding: 16px 12px;
  }
  .order-details-content .section-count .money-box {
    float: none;
    text-align: left;
  }
}
</style>
